export default __webpack_public_path__ + "static/media/office1-after1-1440w.695e7d90.avif";